import {
  apiErrorMessageLocaleId,
  RepositoryError,
  RepositoryErrorDetails,
} from 'repositories/Error';
import { Failure, Result } from 'types';

export class ApplicationError {
  constructor(
    readonly originalMessage?: string,
    readonly errorDetails?: RepositoryErrorDetails
  ) {
    this.originalMessage = originalMessage;
    this.errorDetails = errorDetails;
  }

  localeId(message = ''): string {
    if (message === '') {
      return apiErrorMessageLocaleId(this.originalMessage);
    }
    return apiErrorMessageLocaleId(message);
  }

  static handleForRepositoryError<T>(
    error: unknown,
    handleStatusCodes: number[] = []
  ): Result<T, ApplicationError> {
    if (
      error instanceof RepositoryError &&
      (error.shouldNotRaiseError ||
        handleStatusCodes.length === 0 ||
        handleStatusCodes.includes(error.status))
    ) {
      return new Failure(new ApplicationError(error.message, error.details));
    }

    if (error instanceof RepositoryError) {
      throw new Error(error.message);
    }

    throw error;
  }
}
